module.exports = __webpack_public_path__ + "static/media/CiberalarmaTemplate.94732c00.xlsx";